export default {
    appTitle: "Kunniakierros",

    common: {
        next: "Följande",
        ok: "OK",
    },

    user: {
        username: "Epostadress",
        pin: "PIN-kod",
        password: "Lösenord",
    },

    loginView: {
        title: "Be om PIN-kod",
        login: "Skriv in",

        enterUsername: "Skriv användarnamn",
        nonexistentUser: "Användarnamnet hittas inte. Kontrollera  användarnamn.",

        enterPinHelp: "Skriv PIN-kod, som du fick per epost",
        enterPin: "Sriv din PIN-kod",

        sendPinTitle: "Hittar du inte PIN-koden?",
        sendPinHelp: "Fick du inte  PIN-kod i din epost? Kolla ännu roskpostlådan eller be om ny PIN-kod",//"Tarkista ensin menikö sähköpostiviesti roskapostikansioon. Jos viestiä ei löydy sieltäkään, voit tilata uuden PIN-koodin.",
        sendPin: "Beställ ny PIN-kod",
        
        pinInvalid: "PIN-koden är felaktig",
        pinSentTopic: "PIN har skickats",
        pinSent: "Vi skickade en ny PIN-kod i din epost. Kolla din epost efter en stund och skriv PIN-koden. Samtidigt har den förra PIN-koden åldrats, försäkra dig om att du öppnar nyaste eposten.",

        askForPin: "Be om PIN-kod",
        requestingPin: "Ber om ny PIN-kod...",
    },

    homeView: {
        title: "Förstasidan",
        infoTitle: "Ärevarvet",
        perLap: " / varv",
        totalSponsorPayments: "en möjlighet att samla in åt föreningen",
        sponsorsParticipating: "Du har nu {0} sponsorer", // sponsor(er)
        inviteSponsor: "Bjud med några sponsorer",
        instructions: "Instruktioner", // Insamlings instruktioner
        sponsors: "Sponsorer",
        selectOrganization: "Välj förening",
        selectEvent: "Välj Ärevarv",
        // event: "Insamling",
        event: "Mitt ärevarv",
        eventInfo: "Förening & insamlingskampanj",
        permit: "Insamlingstillstånd",
        logout: "Skriv ut", // TODO: dup. in myProfileView
        goal: "Målsättning:",
        // repeats: "{0} - varv",
        // repeats: "Aseta kierrokset",
        noGoal: "Ingen målsättning",
        repeatsButton: "Varv",
        repeats: "Ange varv",
        noOrganization: "Du är inte anknuten till någon förening. Vänligen kontakta egna föreningens kontaktperson.",
        noEvent: "Du har inte anknutits till någon insamling. Egna insamlingar syns här, efter det som föreningens ansvariga person har lagt dig till som deltagare i insamlingen.",
        addOrInviteSponsors: "Lägg till eller bjud in sponsorer",
        billingInfo: "Nu är det är möjligt att fakturera sponsorer direkt från applikationen! Fakturering görs från vyn för sponsorer. Kontakt din förenings kontaktperson, om du vill aktivera faktureringsfunktionen.",
    },

    myProfileView: {
        title: "Inställningar",
        logout: "Skriv ut",
        saveChanges: "Spara ändringar",
        slogan: "Mitt motto",
        account: "Användarkonto",
        profilePicture: "Profilbild",
        chooseProfilePicture: "Välj profilbild",
        instructions: "Instruktioner",
        language: "Språk",
        locale_fi: "Finska",
        locale_se: "Svenska",
    },

    sponsorsView: {
        title: "Sponsorer",
        sponsors: "Sponsorer",
        participatingSponsors: "Sponsorer som kommit med",
        paymentComplete: "Betalningen är betald",
        sendReminder: "Påminn om betalningen",
        reminderSent: "Päminnelsen har skickats {0}",
        billSent: "Räkning har skickats {0}",
        paymentCompleted: "Betalningen är betald",
        inviteSponsor: "Bjud med en sponsor",
        addSponsor: "Lägg till en sponsor",
        paymentPerRepeat: "Summan för understödet {0} €/varv",
        maxPayment: "totalsumma {0} €",
        paymentManual: "Summan för understödet {0} €",
        sendInvitation: "Skicka inbjudningar",

        sentInvitations: "Skcikade inbjudningar",
        invitedOn: "Inbjudna {0}",
        inviteAgain: "Bjud med på nytt",
        maxPaymentSum: "Maksimisumma",
        // notParticipating: "Deltar inte",
        
        noInvitations: "Inga sända inbjudningar",
    },

    startView: {
        title: "",
        signUp: "Anmäld dig med",
        login: "Skriv in",
        about: "Bekanta dig med",
        footerText: "2018 © Finlands Friidrottsförbund rf",
    },

    inviteSponsorView: {
        title: "Bjud med sponsorer",
        // sendInvitation: "Skicka inbjudan",
        // sendingInvitations: "Inbjudan skickas till",
        sendInvitation: "Skicka inbjudningar",
        sendingInvitations: "Inbjud skickas till",
        inFacebook: "per Facebook", // ?
        viaEmail: "Per epost",
        writeEmailAddress: "Skriv epostadress",
        send: "Skicka",
        emailInvitationSent: "Inbjudan är skickad",
        emailInvitationsSent: "Inbjudningarna har skickats",
        emailInvitationFailed: "Försändelsen av inbjudan misslyckades",
        duplicateSponsor: "Denna sponsor är redan på din lista. Ifall denna sponsor inte har svarat på inbjudan, kan du skicka en ny inbjudan via sponsor-sidan.",
        invitePreviousSponsors: "Bjud med tidigare sponsorer",
        copySponsorLink: "Kopiera inbjudnings länk",
        copied: "Kopierad",
    },

    addSponsorView: {
        title: "Lägg till en ny sponsor.",
        fillSponsorInformation: "Ge sponsorens uppgifter",
        //name: "Nimi",
        firstname: "Förnamn",
        lastname: "Efternamn",
        email: "E-postadress",
        paymentAmount: "Summa som man sponsorerar med (minimi {0}€)",
        paymentPerRepeat: "Summa / varv",
        oneTimePayment: "Engångssumma",
        // maxPayment: "Maksimisumma",
        suggestedTarget: "Toive tukikohteesta", // ?
        saveSponsor: "Spara uppgifterna",
        sponsorAdded: "En sponsor har laggts till",
        company: "Företag",
        companyName: "Företagets namn",
        private: "Privat person",

        streetAddress: "Gatuadress",
        zipCode: "Postnummer",
        city: "Stad",
        info: "Tilläggsinformation",

        paymentMethodMail: "Post",
        paymentMethodEmail: "E-post",
        paymentMethodEInvoice: "E-faktura",

        bank: "Bank",
        eInvoicePaymentAddress: "E-faktureringsadress",
    },

    invitePreviousSponsorsView: {
        inviteSelected: "Skicka inbjudan till utvalda sponsorn",
        selectAll: "Välj alla",
        sendingInvitations: "Inbjudan skickas till",
        invitationsSent: "Inbjudan har skickats",
        noSponsors: "Du har inte tidigare sponsorer",
    },

    chooseOrganizationView: {
        title: "Välj förening",
    },

    chooseEventView: {
        title: "Välj Ärevarv",
        // title: "Välj händelse",
    },

    statisticsView: {
        title: "Statistik",
        userStatistics: "Egen",
        eventStatistics: "Insamling Top {0}",
        organizationStatistics: "Förening",
        topEventParticipants: "Insmlare Top {0}",
        // allStatistics: "Ärevarv",
        allStatistics: "Föreningar Top {0}",
    },

    userStatisticsView: {
        title: "Mina prestationer",
        events: "Insamling", 
        
        event: "Händelse",
        // paidSum: "Insamlade €",
        paidSum: "Betalat €",
        // estimated: "Lovade €",
        estimated: "Insamlat €",

        /*
        numberOfSponsors: "Tukijoiden lkm.:",
        paymentComplete: "Maksettu:",
        paymentPending: "Maksamatta:",
        remindUnpaidSponsors: "Lähetä tukijoille muistutus",
        remindersSent: "Muistutukset lähetetty",
        paid: "Maksettu",
        pending: "Odottaa maksua",
        topParticipants: "Tapahtuman parhaat kerääjät",
        */
    },
    
    eventStatisticsView: {
        topParticipants: "{0} top {1}",
    },

    organizationStatisticsView: {
        events: "Insamling",
    },

    allStatisticsView: {
        numberOfParticipants: "Insamlare",
        topOrganizations: "Ärevarv-föreningar top {0}",
        raisedSum: "Insamlad summa",
    },

    editRepeatsView: {
        title: "Varv",
        setEstimatedLaps: "Ange din målsättnig om antal varv ",
        repeats: "Antalvarv", //"Antalet varv som förverkligats",
        save: "Spara",
    },

    eventParticipantTopList: {
        topParticipants: "Bästa insamlare i evenemanget",
    },

    permissionView: {
        backToHome: "Tillbaka till framsidan",
    },

    mobileAppInstructionsView: {
        title: "Mobilapplikationens instruktioner",
    },
};